import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

export default function AuthShell({ title, subtitle, children, testId }) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-background" data-testid={testId}>
      {/* Visual panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-10 border-r border-border overflow-hidden">
        <div className="aurora" />
        <Link to="/" className="relative flex items-center gap-2 font-display text-lg font-semibold">
          <span className="grid place-items-center w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-400 to-pink-500">
            <Sparkles className="w-4 h-4 text-zinc-950" />
          </span>
          TikBoost <span className="text-cyan-400">AI</span>
        </Link>
        <div className="relative max-w-md">
          <blockquote className="font-display text-2xl leading-relaxed">
            "TikBoost turned my content chaos into a calm system. My weekly output tripled and so did the reach."
          </blockquote>
          <p className="mt-4 text-sm text-muted-foreground">— Ana Ruiz, Creator · 480K</p>
        </div>
        <p className="relative text-xs text-muted-foreground">© {new Date().getFullYear()} TikBoost AI</p>
      </div>
      {/* Form panel */}
      <div className="flex flex-col p-6 sm:p-10">
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-2" data-testid="back-home">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <div className="my-auto w-full max-w-md mx-auto">
          <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-3 text-muted-foreground">{subtitle}</p>}
          <div className="mt-10">{children}</div>
        </div>
      </div>
    </div>
  );
}
